/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPencil3Svg: {
  name: 'pencil_3_svg';
  data: string;
} = {
  name: 'pencil_3_svg',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0-.01h24v24H0Z"/><g><path d="M20.28 8.15l.8-.81c1.22-1.23 1.22-3.213 0-4.44 -1.19-1.19-3.25-1.185-4.436 0l-.81.8 4.44 4.42Z"/><path d="M18.858 9.57L9.749 18.67c-.08.07-.17.14-.26.18l-6.043 3.02c-.39.19-.85.11-1.154-.19 -.31-.31-.38-.77-.19-1.154l3.02-6.05c.04-.1.11-.19.18-.26l9.109-9.109 4.436 4.43Z"/></g></svg>`,
};
